import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setName
} from '../redux/personalDates'

export default function * requestRenamePersonalDate (action) {
  const { id, name } = action.payload

  const state = yield select()

  const currentPersonalDate = state.kanbo.personalDates.byId[id]

  if (!currentPersonalDate) return

  const optimisticAction = yield optimisticPut(setName({
    id,
    name
  }))

  try {
    yield call(apiAction, 'RenamePersonalDate', {
      id,
      name
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
